var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgFemale = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  viewBox: "0 0 16 16"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M1 16c0-3.333 4.638-2.784 5.333-4.667v-.666c-2.518 0-3.942-1.256-3.942-1.256C3.706 8.315 1.883.695 6.367.695c0 0 .604-.695 1.386-.695 5.479 0 3.674 8.273 5.091 9.435 0 0-1.313 1.232-3.844 1.232v.666c.695 1.883 5.333 1.334 5.333 4.667z"
})));
export { SvgFemale as ReactComponent };
export default "data:image/svg+xml;base64,bW9kdWxlLmV4cG9ydHMgPSBfX3dlYnBhY2tfcHVibGljX3BhdGhfXyArICJzdGF0aWMvbWVkaWEvZmVtYWxlLmRiZGQwYjI4LnN2ZyI7";